import React from "react";
import "./styles.css";
/**
 * @function TableView 
 * @param {STRING} label Pass the table label into the component.
 * @param {STRING} data Pass the table data into the component.
 * @returns {React.Component}
 * @example
 * <TableView label="Some label"  data="Some data" />
 */
export default function TableView(props) {
  return (
    <div className="table-view">
      <table className="table-view-container">
        <tbody>
          {props.children}
        </tbody>
      </table>
    </div>
  );
}

export function TableRowView(props) {
  /* Label and data */
  const label = props.label ?? "[[label]]";
  const data = props.data ?? "[[data]]";
  const labelClass = props.labelClass ?? "";
  const dataClass = props.dataClass ?? "";
  const rowClassName = props.rowClassName ?? "";

  const dataPointLabel = props.dataPointLabel ? { "data-point" : props.dataPointLabel } : {};
  const dataPoint = props.dataPoint ? { "data-point" : props.dataPoint } : {};

  return (
    <tr className={rowClassName + " table-row-view"}>
      <td className={`row-label ${labelClass}`}>
        <span { ...dataPointLabel }>{label}</span>
      </td>
      <td className={`row-text ${dataClass}`}>
        <span { ...dataPoint }>{data}</span>
      </td>
    </tr>
  );
}
